import {gsap, Quart} from 'gsap/all';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
import PerfectScrollbar from 'perfect-scrollbar';
import utils from '@/_modules/utils';
import $transitions from '@/_modules/Transitions';

class _gnav {
  constructor() {}

  once(options) {
    this.ispc = false;
    this.isTop = options.isTop;
    this.isOpen = false;
    this.isInit = false;
    this.pastWidth = 0;
    this.pastScrollY = 0;

    this.el = document.getElementById('c-gnav');
    this.header = document.getElementById('c-header');
    this.btnTrigger = document.getElementById('c-trigger');
    this.btnTrigger.addEventListener('click', this.triggerNav.bind(this));
    this.modal = document.getElementById('c-gnav__modal');
    this.menuWhite = this.modal.querySelector('.c-modalNav__col--white');

    if (this.isTop) {
      // TOPページはアンカーリンクにする
      this.settingAnchor();
    }

    this.subAnchor();

    // リンク時にカバーを前面に表示する場合
    this.linkCover = this.el.querySelectorAll('.is-link-cover');
    this.linkCover.forEach((el, i) => {
      el.addEventListener('click', this.settingLink.bind(this, el.href));
    });

    // リサイズ
    window.addEventListener('resize', this.resize.bind(this));

    // スクロールバー
    const ps = new PerfectScrollbar((this.menuWhite));
  }

  // カバーを前面に表示してからリンクする
  settingLink(href, e) {
    e.preventDefault();
    $transitions.show(this.gotoLink.bind(this, href));
  }

  gotoLink(href) {
    location.href = href;
  }

  // アンカーリンクTOP用
  settingAnchor() {
    this.anchors = document.querySelectorAll('#c-menuSet__a a');
    this.anchors.forEach((el, i) => {
      el.addEventListener('click', this.clickAnchor.bind(this, el.hash.replace('#', '')));
    });
  }

  clickAnchor(id, e) {
    if (e) e.preventDefault();
    this.closeNav();
    this.gotoAnchor(id, 'p-top__');
  }

  // アンカーリンク
  subAnchor() {
    const btnAnchors = document.querySelectorAll('.is-btn-anchor');
    btnAnchors.forEach((el, i) => {
      el.addEventListener('click', this.clickSubAnchor.bind(this, el.hash.replace('#', '')));
    });
  }

  clickSubAnchor(id, e) {
    if (e) e.preventDefault();
    this.gotoAnchor(id, '');
  }

  // ページアクセス時にアンカーリンクする
  firstAnchor(id) {
    if (!id) return;
    switch (id) {
      case 'what':
      case 'product':
      case 'casestudy':
      case 'about':
      case 'value':
      case 'company':
        requestAnimationFrame(this.gotoAnchor.bind(this, id, 'p-top__'));
        break;
      default:
    }
  }

  gotoAnchor(id, prefix) {
    if (window.$scroll) {
      const target = document.querySelector(`#${prefix}${id}`);
      window.$scroll.scrollTo(target, {
        offset: 0,
        duration: 800,
        easing: [0.165, 0.84, 0.44, 1],
      });
    } else {
      gsap.to(window, {
        duration: 0.8,
        scrollTo: {y: `#${prefix}${id}`, autoKill: false},
        ease: Quart.easeOut,
      });
    }
  }

  init(namespace) {
    if (this.isInit) return;
    this.isInit = true;
    this.resize()
  }

  reset(namespace) {
    if (!this.isInit) return;
    this.isInit = false;
    this.pastScrollY = 0;
    this.closeNav();
    this.resetPc();
  }

  initPc() {
    this.ispc = true;
    /*
    this.bindScroll = this.scroll.bind(this);

    if (gAMBR.isSmoothScroll) {
      window.$scroll.on('scroll', this.bindScroll);
    } else {
      window.addEventListener('scroll', this.bindScroll);
    }
    */
  }

  resetPc() {
    this.ispc = false;
    /*
    if (gAMBR.isSmoothScroll) {
      window.$scroll.off('scroll', this.bindScroll);
    } else {
      window.removeEventListener('scroll', this.bindScroll);
    }
    delete this.bindScroll;
    */
    gsap.set(this.header, {clearProps: 'all'});
  }

  triggerNav() {
    if (this.isOpen) {
      this.closeNav();
    } else {
      this.openNav();
    }
  }

  openNav() {
    if (this.isOpen) return;
    this.isOpen = true;
    this.el.classList.add('c-gnav--modal-open', 'c-gnav--modal-openIcon');

    const bg = this.modal.querySelector('.c-gnav__modalBg');
    const nav = this.modal.querySelector('.c-modalNav');

    gsap.killTweensOf([bg, nav]);
    gsap.fromTo(bg, {
      x: '-100%',
    }, {
      duration: 0.35,
      x: '0%',
      ease: Quart.easeIn,
    });

    gsap.fromTo(nav, {
      opacity: 0,
      x: -100,
    }, {
      delay: 0.35,
      duration: 0.4,
      opacity: 1,
      x: 0,
      ease: Quart.easeOut,
      onComplete: this.openNavComp.bind(this),
    });
  }

  openNavComp() {
    this.pastScrollY = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;

    const body = document.body;
    body.style.overflow = 'hidden';
    //body.style.overflowX = 'hidden';
    //body.style.overflowY = 'scroll';
    //body.style.position = 'fixed';
    //body.style.height = 'auto';

    gEvent.emit('OPEN_GNAV');
  }

  closeNav() {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.el.classList.remove('c-gnav--modal-openIcon');

    const bg = this.modal.querySelector('.c-gnav__modalBg');
    const nav = this.modal.querySelector('.c-modalNav');

    gsap.killTweensOf([bg, nav]);
    gsap.to(nav, {
      duration: 0.45,
      opacity: 0,
      x: 100,
      ease: Quart.easeOut,
    });

    gsap.to(bg, {
      delay: 0.1,
      duration: 0.35,
      x: '100%',
      ease: Quart.easeOut,
      onComplete: this.closeNavComp.bind(this),
    });

    const body = document.body;
    body.style.overflowX = '';
    body.style.overflowY = '';
    body.style.position = '';
    body.style.height = '';

    window.scrollTo(0, this.pastScrollY);

    gEvent.emit('CLOSE_GNAV');
  }

  closeNavComp() {
    this.el.classList.remove('c-gnav--modal-open');
  }

  start() {
    gAMBR.rootHTML.classList.add('c-gnav--start');
    if (this.isTop) {
      this.firstAnchor(location.hash.replace('#', ''));
    }
  }

  getHeight100() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  resize() {
    this.getHeight100();
    const winW = window.innerWidth;
    if (utils.getMatchMedia()) {
      ///////////////
      // SP
      ///////////////
      if (this.ispc && winW !== this.pastWidth) {
        this.resetPc();
      }
    } else {
      ///////////////
      // PC
      ///////////////
      if (!this.ispc) {
        this.initPc();
      }
    }

    this.pastWidth = window.innerWidth;
  }
}

const gnav = new _gnav();

export default gnav;